import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import * as locations from '../../../../constants/dropdown-spring21';
import {messageTextValidation, nameValidation, emailValidation, phoneValidation} from '../../../../utils/itemValidation';

import * as commonActionCreators from '../../../../actions/common';
let allActionCreators = Object.assign({}, commonActionCreators);

import RhinoSelect from '../../../common/inputs/RhinoSelect';

class Spring2021 extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);

		const firstEntryNotReq = [{display: 'Location', 'value': ''}];
    const finalEntry = [{display: 'Other', 'value': 'online@diamondsdirect.com'}];
    let newArray= firstEntryNotReq.concat(locations.locations).concat(finalEntry);

		this.state = {
			locations: newArray,
			inputName: '',
			inputEmail: '',
			inputPhone: '',
			inputLocation: '',
			inputMessage: '',
			inputDesigner: '',
			designerLocation: '',
			errorName: null,
			errorEmail: null,
			errorPhone: null,
			errorLocation: null,
			errorMessage: null,
			errorDesigner: null,
			errorDesignerLocation: null,
		};
	}

	internalNav(page) {
    this.context.router.push('/' + page);
  }

	externalNav(page) {
    window.location.href = '/' + page;
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

  changeName(evt) {
		this.setState({ inputName: evt.target.value }, () => {
			if(this.state.errorName && !nameValidation(this.state.inputName)) {
				this.setState({ errorName: null });
			}
		});
	}

	changeEmail(evt) {
		this.setState({ inputEmail: evt.target.value }, () => {
			if(this.state.errorEmail && !emailValidation(this.state.inputEmail)) {
				this.setState({ errorEmail: null });
			}
		});
	}

	changePhone(evt) {
		this.setState({ inputPhone: evt.target.value }, () => {
			if(this.state.errorPhone && !phoneValidation(this.state.inputPhone)) {
				this.setState({ errorPhone: null });
			}
		});
	}

	changeLocation(evt) {
		this.setState({ inputLocation: evt.target.value}, () => {
			if(this.state.errorLocation !== false && this.state.inputLocation !== '') {
				this.setState({errorLocation: null});
			}
		});
	}

	submitContactRequest() {
		if(this.validateAll()) {

			let contactData = {
				full_name: this.state.inputName,
				email: this.state.inputEmail,
				phone: this.state.inputPhone,
				location: this.state.inputLocation,
			}

			console.log(this.props);
			this.props.commonSummerContactRequest(contactData);
			// this.props.commonAlert('One of our diamond experts will be in touch shortly.', 'Continue');
			this.props.commonAlert('Thank you for submitting a request! A member of our team will follow up with you shortly.', 'Continue', 'helping', '');
			this.setState({
				inputName: '',
				inputEmail: '',
				inputPhone: '',
				inputLocation: '',
				inputDesigner: '',
				errorName: null,
				errorEmail: null,
				errorPhone: null,
				errorLocation: null,
			});
		}
	}

	validateAll() {

    let hasErrors = true;
    
    // Required params
    let nameError = nameValidation(this.state.inputName);
    let emailError = emailValidation(this.state.inputEmail);
    let locationError = nameValidation(this.state.inputLocation);

    // Optional params
    let phoneError = null;
    if(this.state.inputPhone) {
      phoneError = phoneValidation(this.state.inputPhone);
    }

    if(nameError === null &&
       emailError === null &&
       phoneError === null &&
       locationError === null) {
      hasErrors = false;
    }

    this.setState({
      errorName: nameError,
      errorEmail: emailError,
      errorPhone: phoneError,
      errorLocation: locationError,
    }, () => {
    	console.log(this.state);
    });

    return !hasErrors;
  }

	render() {
		return <div className='Spring2021'>
			<div className="promoBanner">
				<img className='desktop600' src="https://ddw2.diamondsdirect.com/img/home/promo-banners/spring2021/landing/summer_banner.jpg" alt="Diamonds Direct Spring" />
				<img className='mobile600' src="https://ddw2.diamondsdirect.com/img/home/promo-banners/spring2021/landing/summer_banner_mob.jpg" alt="Diamonds Direct Spring" />
			</div>
			<div className="promoBody">
				<div className="promoBodyInner">
					<div className="promoText">
						 Spring is the perfect time to start fresh, and what better way to start your forever? With Diamonds Direct’s unmatched selection, the perfect gift for yourself or the one you love is within reach! Shop with us online or in-store to take advantage of:
					</div>
					<div className="promoTitle">20% Special Savings</div>
					<div className="promoText">
						Visit us and enjoy an expanded selection from top designers at a location near you!
					</div>
					
					<div className="springLocationBlock">
						<div className={"springLocationItem"}>
							<div className="springDates">
								April 9 - 17
							</div>
							<div className='springDatesHr'></div>
							<div className={"springLocations singleLine"}>
								<a className="holiday-location-link" href="/oklahoma-city">Oklahoma&nbsp;City,&nbsp;OK</a>
								&nbsp;<span className='link-em'>|</span>&nbsp;
								<a className="holiday-location-link" href="/cleveland">Cleveland,&nbsp;OH</a>
								<br />
								<a className="holiday-location-link" href="/indianapolis">Indianapolis,&nbsp;IN</a>
								&nbsp;<span className='link-em'>|</span>&nbsp;
								<a className="holiday-location-link" href="/san-antonio">San&nbsp;Antonio,&nbsp;TX</a>
								<br />
								<a className="holiday-location-link" href="/new-orleans">New&nbsp;Orleans,&nbsp;LA</a>
								&nbsp;<span className='link-em'>|</span>&nbsp;
								<a className="holiday-location-link" href="/boca-raton">Boca&nbsp;Raton,&nbsp;FL</a>
								<br />
								<a className="holiday-location-link" href="/virginia-beach">Virginia&nbsp;Beach,&nbsp;VA</a>
							</div>
						</div>
						<div className="springLocationItem">
							<div className="springDates">
								April 16 - 24
							</div>
							<div className='springDatesHr'></div>
							<div className="springLocations">
								<a className="holiday-location-link" href="/charlotte">Charlotte,&nbsp;NC</a>
								&nbsp;<span className='link-em'>|</span>&nbsp;
								<a className="holiday-location-link" href="/raleigh">Raleigh,&nbsp;NC</a>
								<br />
								<a className="holiday-location-link" href="/dallas">Dallas,&nbsp;TX</a>
								&nbsp;<span className='link-em'>|</span>&nbsp;
								<a className="holiday-location-link" href="/frisco">Frisco,&nbsp;TX</a>
								&nbsp;<span className='link-em'>|</span>&nbsp;
								<a className="holiday-location-link" href="/austin">Austin,&nbsp;TX</a>
								<br />
								<a className="holiday-location-link" href="/houston">Houston,&nbsp;TX</a>
								&nbsp;<span className='link-em'>|</span>&nbsp;
								<a className="holiday-location-link" href="/richmond">Richmond,&nbsp;VA</a>
								<br />
								<a className="holiday-location-link" href="/charleston">Charleston,&nbsp;SC</a>
								&nbsp;<span className='link-em'>|</span>&nbsp;
								<a className="holiday-location-link" href="/st-louis">St.&nbsp;Louis,&nbsp;MO</a>
								<br />
								<a className="holiday-location-link" href="/jacksonville">Jacksonville,&nbsp;FL</a>
								&nbsp;<span className='link-em'>|</span>&nbsp;
								<a className="holiday-location-link" href="/columbus">Columbus,&nbsp;OH</a>
								<br />
								<a className="holiday-location-link" href="/kansas-city">Kansas&nbsp;City,&nbsp;KS</a>
								&nbsp;<span className='link-em'>|</span>&nbsp;
								<a className="holiday-location-link" href="/birmingham">Birmingham,&nbsp;AL</a>								
							</div>
						</div>
					</div>
					<div className='promoLegal'>
						*Discount excludes price protected lines and certified diamonds. Cannot be combined with other offers. Discount applied in cart online.
					</div>

				</div>
			</div>
			<div className='formBoxWrapper'>
				<div className='formInnerWrapper'>
					
					<div className='formP'>Walk-in visits are always welcome, but due to precautions and state and local ordinances, showroom space may be limited. We also have our virtual appointment tool so you can continue to shop from the comfort of your own home!</div>

					<div className='formWrapper'>
						<div className='formInputWrapper'>
							<input 
								className={this.state.errorName ? 'textInput error' : 'textInput'}
								type='text' 
								placeholder='Full Name*'
								value={this.state.inputName}
              					onChange={::this.changeName} />
						</div>
						<div className='formInputWrapper'>
							<input 
								className={this.state.errorEmail ? 'textInput error' : 'textInput'}
								type='email' 
								placeholder='Email Address*'
								value={this.state.inputEmail}
              					onChange={::this.changeEmail} />
						</div>
						<div className='formInputWrapper'>
							<input 
								className={this.state.errorPhone ? 'textInput error' : 'textInput'}
								type='text' 
								placeholder='Telephone'
								value={this.state.inputPhone}
              					onChange={::this.changePhone} />
						</div>
						<div className='formInputWrapper'>
							<RhinoSelect
				                selectClass={'summerSelect'}
				                required={true}
				                value={this.state.inputLocation}
				                options={this.state.locations}
				                changeMethod={(evt) => this.changeLocation(evt)}
				                error={this.state.errorLocation !== null} />
						</div>
						<div className='formActionRow'>
							<button className={'formAction'} onClick={::this.submitContactRequest}>Request an appointment</button>
						</div>
					</div>
				</div>
			</div>
			<div className='trendsWrapper'>
				<div className='trendsTitle'>
					<img src='https://ddw2.diamondsdirect.com/img/home/promo-banners/spring2021/landing/spring_trends.svg' />
				</div>
				<div className='trendsImg'>
					<img className='desktop600' src="https://ddw2.diamondsdirect.com/img/home/promo-banners/spring2021/landing/jewelry_block.jpg" alt="Diamonds Direct Spring" />
					<img className='mobile600' src="https://ddw2.diamondsdirect.com/img/home/promo-banners/spring2021/landing/jewelry_block_mob.jpg" alt="Diamonds Direct Spring" />
					<div className='linkScreen1' onClick={() => this.externalNav('setting/MTG1411881')}></div>
					<div className='linkScreen2' onClick={() => this.externalNav('jewelry/BLDMD06217')}></div>
					<div className='linkScreen3' onClick={() => this.externalNav('jewelry/ECLST04668')}></div>
					<div className='linkScreen4' onClick={() => this.externalNav('jewelry/NCOST02488')}></div>
				</div>
			</div>
		</div>;
	}
}
export default Spring2021;

function mapStateToProps(state) {
  return {

  };
}

export const Spring2021Container = connect(
  mapStateToProps,
  allActionCreators
)(Spring2021);


// WEBPACK FOOTER //
// ./src/components/views/promopages/spring2021/Spring2021.jsx